import { render } from "./VehicleAutocomplete.vue?vue&type=template&id=34a9d1cc&ts=true"
import script from "./VehicleAutocomplete.ts?vue&type=script&lang=ts"
export * from "./VehicleAutocomplete.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__